import Axios from 'axios'
import strings from '@/strings'

const client = {
  getClients () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients`)
  }
}

export default client
